export default __webpack_public_path__ + "static/static-asset-people-small-06b991a8a65dd00262ea27888922274e.svg";